module.exports = __webpack_public_path__ + "static/28-93cb268dd8ddaa76e698a65c0ccd8424.jpg";